import type { Middleware } from "openapi-fetch";
import { HttpError } from "../utils/http-error";

export const throwOnErrorMiddleware: Middleware = {
  onResponse: async ({ response }) => {
    if (!response.ok) {
      let data = null;

      try {
        data = await response.clone().json();
      } catch {}

      throw new HttpError(response.status, data);
    }

    return response;
  },
};
